import { Button } from '@crazyegginc/hatch';

import { useAuthContext, usePermissions, useMetric, useManageSubscriptionPath } from '/src/hooks';
import { Paywall } from '/src/components/Paywall';
import { FEATURES } from '/src/features/_global/constants';

import LivePNG from '@crazyegginc/hatch/dist/images/illustration-live-dash.png';
import LiveWebP from '@crazyegginc/hatch/dist/images/illustration-live-dash.webp';
import { ReactComponent as ArrowIcon } from '@crazyegginc/hatch/dist/images/icon-arrow-expand.svg';
import { AppLink } from '/src/features/_global/components/AppLink';

export function LiveUpgradePaywall({ mini }) {
  const { currentAccount } = useAuthContext();
  const trackMetric = useMetric();
  const subscriptionPath = useManageSubscriptionPath();

  const permissions = usePermissions();
  const canManageBilling = permissions.can('edit', FEATURES.BILLING).allowed;
  const isStripeUser = Boolean(currentAccount?.useStripe);

  return (
    <Paywall>
      <Paywall.Image
        webp={LiveWebP}
        fallback={LivePNG}
        width={mini ? '80px' : '175px'}
        className={mini ? '!mb-3 !mt-2' : ''}
      />
      <Paywall.Title mini={mini}>Your website events, live!</Paywall.Title>

      <Paywall.Body>
        View key events happening on your website in real-time. Dive deeper into visitor information, errors and
        heatmaps as they happen.
        {!canManageBilling ? (
          <p className="mt-5">
            To get access to this feature, contact your Account Owner &#40;{currentAccount.ownerEmail}&#41; to upgrade
            the plan.
          </p>
        ) : null}
      </Paywall.Body>

      {canManageBilling ? (
        <Button
          component={AppLink}
          to={subscriptionPath}
          onMouseDown={() => trackMetric('upgrade_cta_click', 'live_activity_upsell_paywall')}
          className="mb-5"
          target={isStripeUser ? '_blank' : '_self'}
          rel={isStripeUser ? 'noopener noreferrer' : undefined}
        >
          Get Live Activity
          <ArrowIcon className="ml-2.5 h-2.5 w-2.5 rotate-90 fill-current" />
        </Button>
      ) : (
        <Button component="a" href={`mailto:${currentAccount.ownerEmail}`} className="mb-5">
          Contact account owner
        </Button>
      )}
    </Paywall>
  );
}
